/**
 * Venue Map
 * Interactive map for theatre event venue display
 */
(function() {
    function cartoKeyParam() {
        const key = (window.siteConfig && window.siteConfig.cartoApiKey) || '';
        return key ? '?key=' + encodeURIComponent(key) : '';
    }

    function escapeHtml(text) {
        if (!text) return '';
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    function initVenueMaps() {
        const panels = document.querySelectorAll('[data-venue-panel]');
        if (!panels.length) return;

        panels.forEach(function(panel) {
            const mapEl = panel.querySelector('[data-venue-map]');
            if (!mapEl) return;

            const markerSvg = mapEl.dataset.markerSvg;
            const markerColor = mapEl.dataset.markerColor || '#C247FF';
            const eventTitle = mapEl.dataset.eventTitle || '';
            const hasMultipleVenues = panel.dataset.multipleVenues === 'true';
            const cardBg = panel.dataset.cardBg || 'bg-white-core';

            if (!markerSvg) return;

            let mapInstance = null;
            let markerInstance = null;

            function createIcon() {
                const svg = markerSvg.replace(/__COLOR__/g, markerColor);
                return L.divIcon({
                    html: '<div style="line-height:0">' + svg + '</div>',
                    iconSize: [35, 35],
                    iconAnchor: [17, 35],
                    popupAnchor: [0, -35],
                    className: ''
                });
            }

            function createPopupContent(venueTitle, mapsUrl) {
                const arrowIcon = '<svg class="bga-popup-link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
                let content = '<div class="bga-popup-inner">' +
                    '<span class="bga-popup-title">' + escapeHtml(eventTitle) + '</span>' +
                    '<span class="bga-popup-venue">' + escapeHtml(venueTitle) + '</span>';
                if (mapsUrl) {
                    content += '<a href="' + escapeHtml(mapsUrl) + '" target="_blank" rel="noopener nofollow" class="bga-popup-link">Get Directions ' + arrowIcon + '</a>';
                }
                content += '</div>';
                return content;
            }

            function ensureMap(lat, lng, zoom, venueTitle, mapsUrl) {
                if (typeof L === 'undefined') {
                    setTimeout(function() { ensureMap(lat, lng, zoom, venueTitle, mapsUrl); }, 50);
                    return;
                }

                if (!mapInstance) {
                    mapInstance = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true });
                    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png' + cartoKeyParam(), {
                        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                        subdomains: 'abcd',
                        maxZoom: 20
                    }).addTo(mapInstance);
                    markerInstance = L.marker([lat, lng], { icon: createIcon() }).addTo(mapInstance);
                    markerInstance.bindPopup(createPopupContent(venueTitle, mapsUrl), { className: 'bga-venue-popup', maxWidth: 260 });
                    mapInstance.setView([lat, lng], zoom);
                    setTimeout(function() { mapInstance.invalidateSize(); }, 100);
                } else {
                    markerInstance.setLatLng([lat, lng]);
                    markerInstance.setPopupContent(createPopupContent(venueTitle, mapsUrl));
                    mapInstance.setView([lat, lng], zoom);
                    mapInstance.invalidateSize();
                }
            }

            // Initialize map for first venue
            const firstLat = parseFloat(mapEl.dataset.firstVenueLat);
            const firstLng = parseFloat(mapEl.dataset.firstVenueLng);
            const firstZoom = parseInt(mapEl.dataset.firstVenueZoom) || 15;
            const firstVenueTitle = mapEl.dataset.firstVenueTitle || '';
            const firstMapsUrl = mapEl.dataset.firstMapsUrl || '';

            if (firstLat && firstLng) {
                ensureMap(firstLat, firstLng, firstZoom, firstVenueTitle, firstMapsUrl);
            }

            // Handle multiple venue buttons
            if (hasMultipleVenues) {
                const venueButtons = panel.querySelectorAll('[data-venue-button]');
                const container = panel.querySelector('[data-venue-map-container]');
                const mapWrapper = container ? container.querySelector('[data-map-wrapper]') : null;
                const placeholder = container ? container.querySelector('[data-venue-map-placeholder]') : null;

                venueButtons.forEach(function(button) {
                    button.addEventListener('click', function() {
                        const lat = parseFloat(this.dataset.venueLat);
                        const lng = parseFloat(this.dataset.venueLng);
                        const zoom = parseInt(this.dataset.venueZoom) || 15;
                        const venueTitle = this.dataset.venueTitle || '';
                        const mapsUrl = this.dataset.venueMapsUrl || '';

                        // Update button states
                        venueButtons.forEach(function(btn) {
                            btn.classList.remove('border-purple-core', cardBg);
                            btn.classList.add('border-transparent', 'bg-transparent');
                            btn.setAttribute('aria-pressed', 'false');
                        });
                        this.classList.remove('border-transparent', 'bg-transparent');
                        this.classList.add('border-purple-core', cardBg);
                        this.setAttribute('aria-pressed', 'true');

                        // Show map or placeholder
                        if (lat && lng && mapWrapper) {
                            mapWrapper.classList.remove('hidden');
                            if (placeholder) placeholder.classList.add('hidden');
                            ensureMap(lat, lng, zoom, venueTitle, mapsUrl);
                        } else {
                            if (mapWrapper) mapWrapper.classList.add('hidden');
                            if (placeholder) {
                                placeholder.classList.remove('hidden');
                                const titleEl = placeholder.querySelector('[data-placeholder-title]');
                                if (titleEl) titleEl.textContent = venueTitle;
                            }
                        }
                    });
                });
            }
        });
    }

    function initSidebarVenueLinks() {
        var links = document.querySelectorAll('[data-sidebar-venue-link]');
        if (!links.length) return;

        links.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                var targetVenueId = this.dataset.targetVenueId;
                var panelId = this.getAttribute('href').replace('#', '');
                var panel = document.getElementById(panelId);
                if (!panel) return;

                // Smooth scroll to the venue panel
                panel.scrollIntoView({ behavior: 'smooth', block: 'start' });

                // After scrolling, activate the matching venue button
                var venueButton = panel.querySelector('[data-venue-button][data-venue-id="' + targetVenueId + '"]');
                if (venueButton && venueButton.getAttribute('aria-pressed') !== 'true') {
                    // Small delay to let scroll settle before triggering the venue switch
                    setTimeout(function() { venueButton.click(); }, 400);
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initVenueMaps();
            initSidebarVenueLinks();
        });
    } else {
        initVenueMaps();
        initSidebarVenueLinks();
    }
})();

